const BaseComponent = require('common/home-block/extend');

class univSwitchImg extends BaseComponent {
  init () {
    super.init();
  }
}

module.exports = univSwitchImg;
